import MyBagRecommendationPDF from './MyBagRecommendationPDF';

export default MyBagRecommendationPDF;
